<template>
	<v-col class="ma-0 pa-0" cols="12" id="head_title">
		<v-col class="pa-0" cols="12" id="main_content_minwidthset">
			<!-- from 대시보드 -->
			<v-row class="ma-0 pa-0 pl-3 pr-3" align="center" id="header_height"
				v-if="playerFromWhere.from === 'dashboard'">
				<v-col class="ma-0 pa-0" cols="auto">
					<v-row class="ma-0 pa-0" align="center">
						<v-col class="ma-0 pa-0" cols="auto">
							<v-btn id="back_clean_btn" width="auto" height="50px"
								class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
								@click="backPage">
								{{tn(prevRoute.name)}}
							</v-btn>
						</v-col>
            <template v-if="routeName === 'videoDownloadSetting'">
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-btn id="back_clean_btn" width="auto" height="50px"
                     class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
                     @click="routerBack">
                {{this.streamData.cameraName}}
              </v-btn>
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-col class="ma-0 pa-0" cols="auto">
                {{'録画データダウンロード'}}
              </v-col>
            </template>
            <template v-else>
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-col class="ma-0 pa-0" cols="auto">
                {{this.streamData.cameraName}}
              </v-col>
            </template>
					</v-row>
				</v-col>
      </v-row>

			<!-- from 점포검색 -->
			<v-row class="ma-0 pa-0 pl-3 pr-3" align="center" id="header_height"
				v-else-if="playerFromWhere.from === 'search'">
				<router-link :to="{ path: '/store-search' }"
					style="color:transparent;">
					<v-col class="ma-0 pa-0" cols="auto" align="center"
						style="color:#08B0FF;font-size:1rem;text-align:center;">
						{{t('top')}}
					</v-col>
				</router-link>
				<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
					src="@/assets/images/history_arrow.png"></v-img>
				<router-link :to="{ path: '/store-search/detail' }"
					style="color:transparent;">
					<v-col class="ma-0 pa-0" cols="auto" align="center"
						style="color:#08B0FF;font-size:1rem;text-align:center;">
						{{tsc('searchResult')}}
					</v-col>
				</router-link>
        <template v-if="routeName === 'videoDownloadSetting'">
          <v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <v-btn id="back_clean_btn" width="auto" height="50px"
                 class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
                 @click="backToStoreSearchCCTV">
            {{$route.query.customerName}}
          </v-btn>
          <v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <router-link :to="{ path: $routerHistory.previous().path }"
                       style="color:transparent;">
            <v-col class="ma-0 pa-0" cols="auto" align="center"
                   style="color:#08B0FF;font-size:1rem;text-align:center;">
              {{this.streamData.cameraName}}
            </v-col>
          </router-link>
          <v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <v-col class="ma-0 pa-0" cols="auto">
            {{'録画データダウンロード'}}
          </v-col>
        </template>
        <template v-else>
          <v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <router-link :to="{ path: $routerHistory.previous().path }"
                       style="color:transparent;">
            <v-col class="ma-0 pa-0" cols="auto" align="center"
                   style="color:#08B0FF;font-size:1rem;text-align:center;">
              {{$route.query.customerName}}
            </v-col>
          </router-link>
          <v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <v-col class="ma-0 pa-0" cols="auto">
            {{this.streamData.cameraName}}
          </v-col>
        </template>
			</v-row>

      <!-- from 지점분할화면 -->
      <v-row class="ma-0 pa-0 pl-3 pr-3" align="center" id="header_height"
             v-else-if="playerFromWhere.from === 'privateSplitScreen'">
        <v-col class="ma-0 pa-0" cols="auto">
          <v-row class="ma-0 pa-0" align="center">
            <v-col class="ma-0 pa-0" cols="auto">
              <v-btn id="back_clean_btn" width="auto" height="50px"
                     class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
                     @click="backPage">
                {{tn(prevRoute.name)}}
              </v-btn>
            </v-col>
            <template v-if="routeName === 'videoDownloadSetting'">
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-btn id="back_clean_btn" width="auto" height="50px"
                       class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
                       @click="backPage">
                  {{splitScreenNameFormat(playerFromWhere.name)}}
                </v-btn>
              </v-col>
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-btn id="back_clean_btn" width="auto" height="50px"
                       class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
                       @click="routerBack">
                  {{this.streamData.cameraName}}
                </v-btn>
              </v-col>
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-col class="ma-0 pa-0" cols="auto">
                {{'録画データダウンロード'}}
              </v-col>
            </template>
            <template v-else>
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-btn id="back_clean_btn" width="auto" height="50px"
                       class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
                       @click="routerBack">
                  {{splitScreenNameFormat(playerFromWhere.name)}}
                </v-btn>
              </v-col>
              <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                     src="@/assets/images/history_arrow.png"></v-img>
              <v-col class="ma-0 pa-0" cols="auto">
                {{this.streamData.cameraName}}
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>

			<!-- from 점포그룹 -->
			<v-row class="ma-0 pa-0 pl-3 pr-3" align="center" id="header_height"
				v-else>
				<router-link :to="{ path: '/store-group/detail?groupId=' + groupId }" style="color:transparent;">
			  	<v-col class="ma-0 pa-0" cols="auto" align="center"
			  		style="color:#08B0FF;font-size:1rem;text-align:center;">
            {{groupName}}
          </v-col>
        </router-link>
        <template v-if="routeName === 'videoDownloadSetting'">
          <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <v-col class="ma-0 pa-0" cols="auto">
            <v-btn id="back_clean_btn" width="auto" height="50px"
                   class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
                   @click="backToStoreGroupCCTV">
              <template v-if="playerFromWhere.from === 'group'">
                {{$route.query.customerName}}
              </template>
              <template v-else-if="playerFromWhere.from === 'cameraList'">
                {{playerFromWhere.name}}
              </template>
              <template v-else>
                {{playerFromWhere.name}}
              </template>
            </v-btn>
          </v-col>
          <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <router-link :to="{ path: $routerHistory.previous().path }"
                       style="color:transparent;">
            <v-col class="ma-0 pa-0" cols="auto" align="center"
                   style="color:#08B0FF;font-size:1rem;text-align:center;">
              {{this.streamData.cameraName}}
            </v-col>
          </router-link>
          <v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <v-col class="ma-0 pa-0" cols="auto">
            {{'録画データダウンロード'}}
          </v-col>
        </template>
        <template v-else>
          <v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <router-link :to="{ path: $routerHistory.previous().path }"
                       style="color:transparent;">
            <v-col class="ma-0 pa-0" cols="auto" align="center"
                   style="color:#08B0FF;font-size:1rem;text-align:center;">
              <template v-if="playerFromWhere.from === 'group'">
                {{$route.query.customerName}}
              </template>
              <template v-else-if="playerFromWhere.from === 'cameraList'">
                {{playerFromWhere.name}}
              </template>
              <template v-else>
                {{playerFromWhere.name}}
              </template>
            </v-col>
          </router-link>
          <v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
                 src="@/assets/images/history_arrow.png"></v-img>
          <v-col class="ma-0 pa-0" cols="auto">
            {{this.streamData.cameraName}}
          </v-col>
        </template>
			</v-row>
		</v-col>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import videoPlayerMixin from '../mixin/index';
import {replaceRoute} from '@/router/navigate';
export default {
	props: {
		role: String,
		authorities: Object,
		streamData: Object,
	},
	components: {
		
	},
	mixins: [mixin.common, videoPlayerMixin],
	data: () => ({
		prevRoute: {},
    groupName: '',
		playerFromWhere: { from: 'dashboard', name: '' },
    groupId: '',
    routeName: '',
	}),
	created() {
		this.checkPrevRoute();
    this.routeName = this.$route.name;
		this.playerFromWhere = this.$store.getters.getPlayerFromWhere;
    if(this.role === 'main' || this.role === 'head') {
      if(this.playerFromWhere.from === 'group' || this.playerFromWhere.from === 'cameraList'
        || this.playerFromWhere.from === 'splitScreen') {
        this.groupId = this.$route.query.groupId;
        const currentGroupIndex = this.$store.state.userData.storeGroupList.findIndex(item => item.id == this.groupId);
        if(currentGroupIndex !== -1) {
          this.groupName = this.$store.state.userData.storeGroupList[currentGroupIndex].groupName;
        }
      }
    }
	},
	methods: {
		checkPrevRoute() {
			const getPrevRoute = JSON.parse(sessionStorage.getItem('prevRoute'));
			if(getPrevRoute) {
				this.prevRoute = {...getPrevRoute};
			} else {
				if(this.role == 'main' || this.role == 'head') {
					if(this.authorities.GET_DASHBOARD) this.prevRoute = { name: 'dashboard', path: '/dashboard' };
					else this.prevRoute = { name: 'notification', path: '/notification' };
				} else {
					if(this.authorities.GET_RECORDING) this.prevRoute = { name: 'privateStoreCCTV', path: '/private/store-cctv' };
					else this.prevRoute = { name: 'privateNotification', path: '/private/notification' };
				}
			}
		},
		backPage() {
			const getPrevRoute = JSON.parse(sessionStorage.getItem('prevRoute'));
			if(getPrevRoute != null || getPrevRoute != undefined) {
				this.replaceRoute(getPrevRoute.path, {});
			} else {
				if(this.role == 'main' || this.role == 'head') {
					if(this.authorities.GET_DASHBOARD) this.replaceRoute("/dashboard", {});
					else this.replaceRoute("/notification", {});
				} else {
					if(this.authorities.GET_RECORDING) this.replaceRoute("/private/store-cctv", {});
					else this.replaceRoute("/private/notification", {});
				}
			}
		},
    goPrivateSplitScreen() {
      this.routerBack();
    },
    splitScreenNameFormat(name) {
      if(name.includes('名称未設定')) return name.substring(0,5);
      else return name;
    },
    backToStoreSearchCCTV() {
      replaceRoute('/store-search/store-cctv', {
        unisCustomerCd: this.$route.query.unisCustomerCd
      });
    },
    backToStoreGroupCCTV() {
      replaceRoute('/store-search/store-cctv', {
        unisCustomerCd: this.$route.query.unisCustomerCd,
        groupId: this.$route.query.groupId,
      });
    },
	}
}
</script>

<style lang="scss" scoped>
#back_clean_btn {
  &:before {
    background-color: transparent !important;
  }
}
</style>